var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankLoan = function SvgBankLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.03 4.005a.688.688 0 0 0-.688-.688H20.68a.688.688 0 0 0-.687.688V54.01c0 .38.308.688.687.688h37.662c.38 0 .688-.308.688-.688V4.005Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M28.373 2.917v51.734"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 52.727 21.12)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 52.727 32.616)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 52.727 44.112)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 40.266 21.12)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 52.727 9.623)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 40.266 9.623)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 40.266 32.616)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.79,
    height: 4.79,
    rx: 1,
    transform: "matrix(-1 0 0 1 40.266 44.112)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.313 2.916a1.916 1.916 0 0 1-1.917 1.916H18.721a1.916 1.916 0 1 1 0-3.832h41.675c1.059 0 1.916.858 1.916 1.916Z",
    fill: "#CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.215 1h4.181c1.059 0 1.916.858 1.916 1.916v0a1.916 1.916 0 0 1-1.916 1.916H18.721a1.916 1.916 0 0 1-1.916-1.916v0c0-1.058.858-1.916 1.916-1.916h24.86",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.267 16.182c-.406-.765.32-1.638 1.146-1.377a1.936 1.936 0 0 0 1.485-.133l1.104-.58a2.549 2.549 0 0 1 2.408.017l1.085.592a2.55 2.55 0 0 0 2.441 0l1.085-.592a2.549 2.549 0 0 1 2.408-.018l1.104.581c.457.24.992.289 1.485.133.826-.26 1.552.612 1.146 1.377l-3.396 6.388a1.275 1.275 0 0 1-1.126.676H13.79c-.472 0-.905-.26-1.126-.676l-3.396-6.388Z",
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.416 23.852a2.86 2.86 0 0 1 2.022-.837h6.553a2.86 2.86 0 0 1 2.022.837l5.21 5.21a21.001 21.001 0 0 1 6.075 13.066l.078.906a11.917 11.917 0 0 1-4.5 10.373 19.652 19.652 0 0 1-24.324 0 11.917 11.917 0 0 1-4.499-10.373l.078-.906a21.003 21.003 0 0 1 6.075-13.066l5.21-5.21Z",
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 41.264a7.885 7.885 0 1 1-15.77 0 7.885 7.885 0 0 1 15.77 0Z",
    fill: "#FFC93C",
    stroke: "#000",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.72,
    cy: 41.264,
    r: 5.336,
    fill: "#FFC93C",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round",
    strokeDasharray: "3.82 2.17"
  })));
};
export default SvgBankLoan;